import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {RichText} from 'prismic-reactjs';
import {SLICE_PROP_TYPES} from 'cms/proptypes';
import {
    Box,
    Container,
    Grid,
    GridItem,
    Heading,
    Accordion,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    AccordionButton,
} from '@spothero/ui/';
import {getSliceThemeVariables, bodySerializer} from 'cms/utils';
import usePrismicInterpolateText from 'hooks/use-prismic-interpolate-text';

const FAQAccordion = ({slice, isMidFunnel}) => {
    const {
        primary: {
            section_id: sectionId,
            slice_theme: sliceTheme,
            faq_title: faqTitle,
            is_accordion: isAccordion,
        },
        items: faqItems,
    } = slice;
    const {textColor, backgroundColor} = getSliceThemeVariables(
        sliceTheme ? sliceTheme : 'Light - Secondary'
    );
    const {interpolate} = usePrismicInterpolateText();

    return (
        <Box
            as="section"
            id={sectionId}
            data-testid="FAQAccordion"
            color={textColor}
            backgroundColor={backgroundColor}
            paddingY={isMidFunnel ? 0 : {base: 8, tablet: 16}}
            marginY={isMidFunnel ? {base: 8, desktop: 12} : 0}
        >
            <Container>
                <Grid>
                    <GridItem
                        colStart={{base: 0, desktop: 3}}
                        colSpan={{base: 12, desktop: 8}}
                    >
                        <Heading
                            as="h2"
                            textAlign="center"
                            marginBottom={{base: 6, tablet: 8}}
                        >
                            {interpolate(faqTitle)}
                        </Heading>
                        {!isAccordion ? (
                            faqItems.map((faq, i) => (
                                <Fragment key={i}>
                                    <Heading
                                        as="h3"
                                        variant="h4"
                                        marginBottom="4"
                                    >
                                        {interpolate(faq.question)}
                                    </Heading>
                                    <RichText
                                        render={faq.answer}
                                        htmlSerializer={bodySerializer()}
                                    />
                                </Fragment>
                            ))
                        ) : (
                            <Accordion allowToggle>
                                {faqItems.map((faq, i) => (
                                    <AccordionItem key={i}>
                                        <Heading as="h3">
                                            <AccordionButton>
                                                <Box flex="1" textAlign="left">
                                                    {interpolate(faq.question)}
                                                </Box>
                                                <AccordionIcon />
                                            </AccordionButton>
                                        </Heading>
                                        <AccordionPanel>
                                            <RichText
                                                render={faq.answer}
                                                htmlSerializer={bodySerializer({
                                                    lazyLoadImages: false,
                                                })}
                                            />
                                        </AccordionPanel>
                                    </AccordionItem>
                                ))}
                            </Accordion>
                        )}
                    </GridItem>
                </Grid>
            </Container>
        </Box>
    );
};

/* eslint-disable camelcase */
FAQAccordion.propTypes = {
    slice: PropTypes.shape({
        ...SLICE_PROP_TYPES,
        primary: PropTypes.shape({
            section_id: PropTypes.string,
            slice_theme: PropTypes.string,
            faq_title: PropTypes.string.isRequired,
            is_accordion: PropTypes.bool.isRequired,
        }).isRequired,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                question: PropTypes.string.isRequired,
                answer: PropTypes.array.isRequired,
            })
        ).isRequired,
    }).isRequired,
    isMidFunnel: PropTypes.bool,
};
/* eslint-enable camelcase */

export default FAQAccordion;
